import VerificationError from "../../components/Auth/VerificationError";
function VerificationErrorPage() {
    return <VerificationError />;
}
export default VerificationErrorPage;